import type {ActionableConditionKind} from '@chekin/shared/remote-access';
import {PATHS} from 'routes/constants';

export {getConditionRows} from '@chekin/shared/remote-access';
export type {
  ActionableConditionKind,
  ActionableConditionRow,
  LockConditionKind,
  LockConditionRow,
} from '@chekin/shared/remote-access';

const CONDITION_PATHS: Record<Exclude<ActionableConditionKind, 'payment'>, string> = {
  registration: PATHS.guestRegistration,
  verification: PATHS.guestRegistration,
  checklist: PATHS.home,
};

type PathHelpers = {
  getFullPath: (path: string) => string;
  getMainPath: (path: string) => string;
  paymentsEntryPath: string;
};

export function resolveConditionPath(
  kind: ActionableConditionKind,
  {getFullPath, getMainPath, paymentsEntryPath}: PathHelpers,
) {
  return kind === 'checklist'
    ? getMainPath(CONDITION_PATHS.checklist)
    : getFullPath(kind === 'payment' ? paymentsEntryPath : CONDITION_PATHS[kind]);
}
